import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

export default {
  namespaced: true,
  state() {
    return {
      feeds: [],
      loading: false,
      error: null,
      contributors:[],
      followedOrgs:[],
      allContributors:[],
      reactedFeed: {},
      innerHeight:null,
      feedPage: 1,
      hasMoreFeedPages: true,
      recommendedConnections: [],
      recommendedOrganizations: [],
      postActivity: new Map(),
      commentActivity: new Map(),
      loadingFollowers: false,
      loadingFollowedOrgs: false,
      activityLoader: false,
      feedComments: [],
      allOrganization:[], // not contributors,
      sharedPostId: '',
      activityPage: 1,
      commentPage: 1,
      hasMoreActivityPages: false,
      hasMoreCommentPages: false,
      activeKey:{
        name: 'feed',
        key: 0
      }
    };
  },
  actions,
  mutations,
  getters,
};
